import { SensitiveDataFormField } from "types/Models/sensitiveData";
import {
  SENSITIVE_DATA_BANK_ENTRY_MODE,
  SENSITIVE_DATA_BANK_ENTRY_MODE_KEY,
  SENSITIVE_DATA_MANUAL_BANK_KEY,
} from "constants/sensitiveData";
import { MANUAL_BANK_ACCOUNT_INITIAL_VALUES } from "types/Models/manualBankAccount";
import { SensitiveDataFormValues } from "./buildSensitiveDataPayload";

const BOOLEAN_TRUE = "true";

export const getSensitiveDataInitialValues = (
  fields: SensitiveDataFormField[],
  manualBank = MANUAL_BANK_ACCOUNT_INITIAL_VALUES
): SensitiveDataFormValues => {
  const values = fields.reduce((acc, field) => {
    if (field.data_type === "BOOLEAN") {
      acc[field.field_key] = String(field.value).toLowerCase() === BOOLEAN_TRUE;
      return acc;
    }

    acc[field.field_key] = field.value;
    return acc;
  }, {} as SensitiveDataFormValues);

  const hasBankField = fields.some(
    ({ data_type }) => data_type === "BANK_ACCOUNT"
  );

  if (!hasBankField) return values;

  return {
    ...values,
    [SENSITIVE_DATA_BANK_ENTRY_MODE_KEY]: SENSITIVE_DATA_BANK_ENTRY_MODE.SAVED,
    [SENSITIVE_DATA_MANUAL_BANK_KEY]: manualBank,
  };
};
